import { useModalState } from "@clipboard-health/ui-components";
import { useIsBadgeVerificationRedesignEnabled } from "@src/appV2/redesign/WorkBadges/hooks/useIsBadgeVerificationRedesignEnabled";
import { useEffect, useRef } from "react";

import { useShouldShowBadgeVerificationResult } from "./useShouldShowBadgeVerificationResult";

export function useBadgeVerificationResult(workerId: string) {
  const modalState = useModalState("closed");
  const hasShownRef = useRef(false);
  const isBadgeVerificationRedesignEnabled = useIsBadgeVerificationRedesignEnabled();

  const { data, shouldShow } = useShouldShowBadgeVerificationResult({
    workerId,
    enabled: isBadgeVerificationRedesignEnabled,
  });

  useEffect(() => {
    if (isBadgeVerificationRedesignEnabled && shouldShow && !hasShownRef.current) {
      hasShownRef.current = true;
      modalState.openModal();
    }
  }, [isBadgeVerificationRedesignEnabled, shouldShow, modalState]);

  return { modalState, data };
}
